import { Link } from "react-router-dom";
import Breadcrumbs from "@/components/site/Breadcrumbs";
import Seo from "@/components/site/Seo";
import { Img } from "@/assets";

const PRODUCTS = [
  { name: "Gold doré", body: "Raw, unrefined gold doré sourced through partner relationships and delivered to refining and industrial counterparties.", img: "gold-dore-industrial" },
  { name: "Silver", body: "Non-manufactured silver traded into industrial and institutional demand channels.", img: "silver-industrial" },
  { name: "Platinum", body: "Raw platinum, traded alongside our gold and silver activities without downstream manufacturing.", img: "platinum-industrial" },
];

export default function PreciousMetals() {
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="metals-hero">
        <div className="gp-page-hero__img" aria-hidden="true"><Img id="gold-dore-industrial" alt="" /></div>
        <div className="gp-wrap gp-page-hero__inner">
          <Breadcrumbs trail={[{ to: "/divisions", label: "Our Divisions" }, { to: "/divisions/precious-metals", label: "Precious Metals" }]} />
          <h1 className="gp-h1 gp-page-hero__title" style={{ marginTop: 20 }}>Raw, non-manufactured precious metals.</h1>
          <p className="gp-page-hero__lede">
            Our Precious Metals division trades raw, non-manufactured metals — gold doré, silver and
            platinum. We do not manufacture or sell jewellery.
          </p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="metals-products">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">01</span><span className="gp-eyebrow-sep" /> Products
          </div>
          <h2 className="gp-h2" style={{ maxWidth: "22ch", marginBottom: 56 }}>Metals we trade.</h2>
          <div className="gp-products">
            {PRODUCTS.map((p, i) => (
              <div className="gp-product" key={p.name} data-testid={`product-${slug(p.name)}`}>
                <div className="gp-product__num">{String(i + 1).padStart(2, "0")} / Product</div>
                <div className="gp-product__name">{p.name}</div>
                <p className="gp-product__body">{p.body}</p>
              </div>
            ))}
          </div>
          <div className="gp-callout">
            <p>This is a corporate information page. For enquiries about supply relationships, please contact us directly.</p>
            <Link to="/contact" className="gp-btn gp-btn--on-white" data-testid="metals-cta-contact">Contact us <span className="gp-arrow">→</span></Link>
          </div>
        </div>
      </section>

      <section className="gp-on-navy" style={{ paddingBlock: "clamp(48px, 6vw, 96px)" }}>
        <div className="gp-wrap" style={{ display: "flex", justifyContent: "space-between", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
          <div className="gp-eyebrow" style={{ margin: 0 }}><span className="gp-eyebrow-sep" /> Next</div>
          <Link to="/divisions/petroleum-energy" className="gp-link" data-testid="metals-cta-petroleum">Petroleum &amp; Energy division <span className="gp-arrow">→</span></Link>
        </div>
      </section>
    </>
  );
}
function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""); }
